<template>
  <div class="duplicate-step1">
    <!-- Project layout reusing existing UI design -->
    <div id="edit__project__modal" class="project-modal edit-deliverable-modal edit-project-modal duplicate-preview">
      <div class="project--top--section duplication-wizard">
        <div class="row">
          <!-- Left Side -->
          <div class="col-md-8 d-flex left--side">
            <div class="project--page--title">
              <!-- <h2 class="d-inline-block">
                <div class="project-icon bigger-icon pointer-default"
                  :style="{ backgroundColor: getProjectColor(sourceProject) }">
                  <img src="@/csmworkflow/img/white-folder.svg" />
                </div>
              </h2> -->
              <div class="text--section">
                <!-- Department -->
                <div class="project--department--wrap">
                  <ProjectDepartments :deliverable="sourceProject" :is-duplication="true" />
                </div>

                <!-- Editable New Project Title -->
                <label class="mb-0 w-100">
                  <h1 style="line-height: 1;" @click="activateTitleField"
                    class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle">
                    {{ newTitle || 'Click to set...' }}
                  </h1>
                  <textarea v-click-outside="deactivateTitleField" ref="projectTitle" v-show="editTitle"
                    v-model="newTitle" type="text" placeholder="New project title..."
                    class="form-control mb-3 title-field exclude-outside-click h1"
                    @blur="editTitle = false;"></textarea>
                  <div v-if="nameValidationState === false" class="text-danger small mt-1">
                    {{ !newTitle.trim() ? 'Project name is required' : 'A project with this name already exists' }}
                  </div>
                </label>
                <div class="project-number">
                  <span>Project Number: {{ sourceProject.project_number }}</span>
                </div>

                <!-- Deadline -->
                <div class="project-due-date">
                      Deadline:
                      <span class="editable-project-due-date">
                        <datepicker
                          v-model="sourceProject.due_date"
                          @selected="editDeadline = false"
                          placeholder="No Date"
                        >
                          <div slot="beforeCalendarHeader" class="calender-header">
                            <b-button class="remove-dl-btn" variant="text" @click="sourceProject.due_date = null">Remove Deadline</b-button>
                            <b-button class="today-btn" variant="text" @click="sourceProject.due_date = new Date().toISOString().slice(0,10)">Today</b-button>
                          </div>
                        </datepicker>
                      </span>
                </div>
              </div>
            </div>

            <!-- Milestones (read-only) -->
            <div v-if="projectDeliverables && projectDeliverables.length" class="project--milestones">
              <label class="field-label">PROJECT MILESTONES</label>
              <div class="project--milestones-wrap">
                <div
                  :class="{ 'active': projectDeliverables[index - 1].is_complete == 1, 'dots': index <= projectDeliverables.length }"
                  class="milestone" v-for="index in projectDeliverables.length" :key="'ms-' + index">
                  <span class="milestone--full--deliverable">&nbsp;</span>
                  <div class="milestone--task--expanson">
                    <span
                      :style="{ backgroundColor: tryJSONParse(getFieldJson(projectDeliverables[index - 1].tasks[index1 - 1].taskFields, 'status').value).color }"
                      v-for="index1 in projectDeliverables[index - 1].tasks.length"
                      :key="'ms-task-' + index + '-' + index1">&nbsp;</span>
                  </div>
                </div>
              </div>
              <div class="dates">
                <span class="left">{{ sourceProject.start_date | moment("MMMM DD, YYYY") }}</span>
                <span class="right">{{ sourceProject.due_date | moment("MMMM DD, YYYY") }}</span>
              </div>
            </div>

            <!-- Project Detail fields -->
            <div class="field-box project--detail--field"
              v-for="(field, index) in projectDetailFields"
              :key="'prj__detail__' + index">
              <ProjectCustomFields :deliverable="sourceProject" :customField="field" :is-duplication="true" />
            </div>

            <div class="project--resources">
              <div class="dropdown project--resources--title">
                <button title="Add resource" class="add-resource-button exclude-outside-click d-inline-block"
                  id="add-resource-button" data-toggle="dropdown" aria-expanded="false">Resources</button>
                <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
                <div class="dropdown-menu project--resources--type--menu">
                  <a class="dropdown-item" href="#" v-for="(type, i) in optionsForLinkType" :key="i"
                    @click="addResourceMenuItemClick(type, $event)"><img class="link-type-icon"
                      :src="require(`@/csmworkflow/img/${type.icon}`)"> {{ type.name }}</a>
                </div>
              </div>

              <div :class="getProjectResourcesClass">
                <div class="resource-entry resource-box editable"
                  v-for="(resource, index) in resourceFields"
                  :key="'link_url-' + index" v-if="showResourceBox(resource.value, resource.pfv_id)">
                  <img class="link-type-icon"
                    :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type', resource.pfv_id)).icon}`)"
                    draggable="false">
                  <div class="resource-box__url"></div>
                  <a class="resource-link" v-if="resource.value" :href="resource.value" target="_blank"
                    :id="`project-resource-${index}`">{{ customChildFieldValue('link_label', resource.pfv_id) ||
                      resource.value }}</a>
                  <a class="resource-link" v-if="!resource.value" :href="getResourceHref(resource.value, resource.pfv_id)"
                    target="_blank" :id="`project-resource-${index}`">{{
                      customChildFieldValue('link_label', resource.pfv_id) || resource.value }}</a>
                  <a title="Edit resource" class="edit-resource-btn" href="#" @click.prevent="editResource(resource)">
                    <i class="fas fa-edit"></i>
                  </a>

                  <div class="resource-box__notes" v-if="customChildFieldValue('link_notes', resource.pfv_id)">
                    {{ customChildFieldValue('link_notes', resource.pfv_id) }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side -->
          <div class="col-md-4 right--side">
            <div class="project-right-side-fields">
              <!-- Engagement Manager -->
              <div class="field-box"
                v-if="sourceProject.engagement_manager && getSystemSetting('project__show_engagement_manager')">
                <ProjectCustomFields
                  :deliverable="sourceProject"
                  :customField="{ field_key: 'engagement_manager', field_name: 'engagement_manager', label: 'Engagement Manager' }"
                  :is-duplication="true"
                />
              </div>

              <!-- Project Lead -->
              <div class="field-box"
                v-if="sourceProject.project_lead && typeof sourceProject.project_leaders == 'undefined'">
                <ProjectCustomFields
                  :deliverable="sourceProject"
                  :customField="{ field_key: 'project_lead', field_name: 'project_lead', label: getSystemSetting('project__project_lead_label') || 'PROJECT LEAD' }"
                  :is-duplication="true"
                />
              </div>

              <!-- Project Leaders (multiple) -->
              <div class="field-box"
                v-if="typeof sourceProject.project_leaders != 'undefined'">
                <ProjectCustomFields
                  :deliverable="sourceProject"
                  :customField="{ field_key: 'project_leaders', field_name: 'project_leaders', label: getSystemSetting('project__project_lead_label') || 'PROJECT LEADERS' }"
                  :is-duplication="true"
                />
              </div>

              <!-- Status -->
              <div class="field-box"
                v-for="(field, index) in statusFields"
                :key="'prj__status__' + index">
                <ProjectCustomFields :deliverable="sourceProject" :customField="field" :is-duplication="true" />
              </div>

              <!-- Audience -->
              <div class="field-box"
                v-for="(field, index) in audienceFields"
                :key="'prj__audience__' + index">
                <ProjectCustomFields :deliverable="sourceProject" :customField="field" :is-duplication="true" />
              </div>

              <!-- Budget -->
              <div class="field-box"
                v-for="(field, index) in budgetFields"
                :key="'prj__budget__' + index">
                <ProjectCustomFields :deliverable="sourceProject" :customField="field" :is-duplication="true" />
              </div>

              <!-- Requisition Number -->
              <div class="field-box"
                v-for="(field, index) in requisitionFields"
                :key="'prj__requisition__' + index">
                <ProjectCustomFields :deliverable="sourceProject" :customField="field" :is-duplication="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal centered no-close-on-backdrop hide-footer id="createProjectLinkModal" title="New Resource / Link"
      @shown="focusLinkModal">
      <CreateProjectLinkModal ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" :is-file="editLinkIsFile"
        :resource-parent="'project'" :is-duplication="true" @save-duplication-resource="saveDuplicationResource" />
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="editProjectLinkModal" title="Update Resource / Link"
      @shown="focusEditLinkModal">
      <EditProjectLinkModal ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile"
        :is-duplication="true" @remove-duplication-resource="removeDuplicationResource" />
    </b-modal>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProjectCustomFields from "../common/ProjectCustomField";
import CreateProjectLinkModal from "../deliverables/CreateProjectLinkModal";
import EditProjectLinkModal from "../deliverables/EditProjectLinkModal";
import ProjectDepartments from "../deliverables/ProjectDepartments";
import Datepicker from "vuejs-datepicker";

export default {
  name: "DuplicateStep1ProjectDetails",
  components: {
    ProjectCustomFields,
    CreateProjectLinkModal,
    EditProjectLinkModal,
    ProjectDepartments,
    Datepicker,
  },
  props: {
    allProjects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      nameExists: false,
      checkTimeout: null,
      editTitle: false,
      editDeadline: false,
      dupResourceCounter: -1,
      linkUrl: null,
      linkLabel: null,
      linkNotes: null,
      linkType: null,
      editLinkIsFile: false,
    };
  },
  computed: {
    ...mapState({
      duplicationWizard: state => state.duplicationWizard,
    }),
    ...mapGetters([
      "systemSettings",
      "getSystemSetting",
      "allProjectDeliverablesPaginationData",
      "allCustomFields",
    ]),
    sourceProject() {
      return this.duplicationWizard.sourceProject || {};
    },
    projectDeliverables() {
      return this.sourceProject.deliverables || [];
    },
    options() {
      return this.duplicationWizard.projectOptions;
    },
    newTitle: {
      get() {
        return this.duplicationWizard.projectOptions.title;
      },
      set(val) {
        this.$store.commit("SET_DUPLICATION_TITLE", val);
        this.onTitleInput();
      },
    },
    deliverableCount() {
      if (this.allProjectDeliverablesPaginationData && this.allProjectDeliverablesPaginationData.total) {
        return this.allProjectDeliverablesPaginationData.total;
      }
      if (this.sourceProject.deliverables) {
        return this.sourceProject.deliverables.length;
      }
      return this.duplicationWizard.allDeliverableIds.length;
    },
    projectDetailFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'project_detail');
    },
    resourceFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'link_url');
    },
    statusFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'project_status');
    },
    audienceFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'project_audience');
    },
    budgetFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'budget');
    },
    requisitionFields() {
      if (!this.sourceProject.customFields) return [];
      return this.sourceProject.customFields.filter(f => f.field_key === 'requisition_number');
    },
    optionsForLinkType() {
      const linkTypeField = this.allCustomFields.find(field => field.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
        return [];
      }
      return JSON.parse(linkTypeField.value_set);
    },
    getProjectResourcesClass() {
      return {
        'project--resources--content': true,
        'field-box__content': true,
        'has-entries': this.resourceFields.some(resource => this.showResourceBox(resource.value, resource.pfv_id)),
      };
    },
    nameValidationState() {
      if (!this.newTitle || !this.newTitle.trim()) return false;
      if (this.nameExists) return false;
      return null;
    },
  },
  methods: {
    activateTitleField() {
      this.editTitle = true;
      this.$nextTick(() => {
        if (this.$refs.projectTitle) {
          this.$refs.projectTitle.focus();
        }
      });
    },
    deactivateTitleField() {
      this.editTitle = false;
    },
    onTitleInput() {
      clearTimeout(this.checkTimeout);
      this.checkTimeout = setTimeout(() => {
        this.checkDuplicateName();
      }, 300);
    },
    checkDuplicateName() {
      const trimmed = this.newTitle.trim();
      if (!trimmed) {
        this.nameExists = false;
        return;
      }
      const existing = this.allProjects.map(p => p.title.toLowerCase().replace(/\s+/g, ''));
      this.nameExists = existing.includes(trimmed.toLowerCase().replace(/\s+/g, ''));
    },
    focusLinkModal() {
      if (this.$refs.refLinkModal) {
        this.$refs.refLinkModal.focusMyElement();
      }
    },
    focusEditLinkModal() {
      if (this.$refs.refEditLinkModal) {
        this.$refs.refEditLinkModal.focusMyElement();
      }
    },
    isValid() {
      return this.newTitle && this.newTitle.trim() && !this.nameExists;
    },
    getResourceHref(url, parentId) {
      const label = this.customChildFieldValue('link_label', parentId);
      const fileId = this.customChildFieldValue('file_id', parentId);
      if (url == null && fileId != null && label) {
        return `/downloadFileProject/${this.sourceProject.id}/${fileId}`;
      }
      return "";
    },
    showResourceBox(url, parentId) {
      const fileId = this.customChildFieldValue('file_id', parentId);
      return url != null || fileId != null;
    },
    customChildField(key, parentId) {
      if (!this.sourceProject.customFields) return [];
      const matches = this.sourceProject.customFields.filter(field => field.field_key === key && field.parent_id === parentId);
      if (matches.length > 0) {
        return matches;
      }
      if (key === 'file_id') return null;
      if (key === 'link_type') return [];
      const field = this.allCustomFields.find(item => item.field_key === key);
      if (!field) return [];
      return [{
        id: null,
        parent_id: parentId,
        project_id: this.sourceProject.projectId || this.sourceProject.id,
        editing: false,
        field_id: field.id,
        field_key: field.field_key,
        field_parent_id: field.parent_id,
        field_type: field.field_type,
        note: field.note,
        value: null,
        label: field.label,
        value_set: field.value_set,
      }];
    },
    customChildFieldValue(key, parentId) {
      if (!this.sourceProject.customFields) return null;
      const match = this.sourceProject.customFields.find(field => field.field_key === key && field.parent_id === parentId);
      return match ? match.value : null;
    },
    editResource(resource) {
      this.linkUrl = resource;
      const label = this.customChildField('link_label', resource.pfv_id);
      this.linkLabel = label && label.length > 0 ? label[0] : {};
      const notes = this.customChildField('link_notes', resource.pfv_id);
      this.linkNotes = notes && notes.length > 0 ? notes[0] : {};
      const type = this.customChildField('link_type', resource.pfv_id);
      if (type && type.length > 0) {
        this.linkType = type[0];
      } else {
        const linkTypeTemplate = this.sourceProject.customFields.find(field => field.field_key === 'link_type');
        this.linkType = {
          id: null,
          field_id: 37,
          project_field_id: linkTypeTemplate ? linkTypeTemplate.projectFieldId : null,
          parent_field_id: 20,
          field_key: "link_type",
          field_type: "select",
          parent_id: resource.pfv_id,
          project_id: this.sourceProject.projectId || this.sourceProject.id,
          value: 1,
        };
      }
      this.editLinkIsFile = Boolean(this.customChildFieldValue('file_id', resource.pfv_id));
      this.$bvModal.show("editProjectLinkModal");
    },
    addResource(typeId = 1, modalId) {
      const linkUrlTemplate = this.sourceProject.customFields.find(field => field.field_key === 'link_url');
      const linkLabelTemplate = this.sourceProject.customFields.find(field => field.field_key === 'link_label');
      const linkNotesTemplate = this.sourceProject.customFields.find(field => field.field_key === 'link_notes');
      const linkTypeTemplate = this.sourceProject.customFields.find(field => field.field_key === 'link_type');
      this.linkUrl = {
        id: null,
        field_id: 20,
        project_field_id: linkUrlTemplate ? linkUrlTemplate.projectFieldId : null,
        parent_field_id: null,
        field_key: "link_url",
        field_type: "text",
        parent_id: null,
        project_id: this.sourceProject.projectId || this.sourceProject.id,
        value: null,
      };
      this.linkLabel = {
        id: null,
        field_id: 21,
        project_field_id: linkLabelTemplate ? linkLabelTemplate.projectFieldId : null,
        parent_field_id: 20,
        field_key: "link_label",
        field_type: "text",
        parent_id: null,
        project_id: this.sourceProject.projectId || this.sourceProject.id,
        value: null,
      };
      this.linkNotes = {
        id: null,
        field_id: 22,
        project_field_id: linkNotesTemplate ? linkNotesTemplate.projectFieldId : null,
        parent_field_id: 20,
        field_key: "link_notes",
        field_type: "text",
        parent_id: null,
        project_id: this.sourceProject.projectId || this.sourceProject.id,
        value: null,
      };
      this.linkType = {
        id: null,
        field_id: 37,
        project_field_id: linkTypeTemplate ? linkTypeTemplate.projectFieldId : null,
        parent_field_id: 20,
        field_key: "link_type",
        field_type: "select",
        parent_id: null,
        project_id: this.sourceProject.projectId || this.sourceProject.id,
        value: typeId,
      };
      this.$bvModal.show(modalId);
    },
    addResourceMenuItemClick(type, event) {
      event.preventDefault();
      this.editLinkIsFile = type.slug == "file";
      this.addResource(type.id, "createProjectLinkModal");
    },
    saveDuplicationResource() {
      const tempPfvId = this.dupResourceCounter--;
      this.linkUrl.pfv_id = tempPfvId;
      this.linkUrl.parent_id = null;
      this.linkLabel.parent_id = tempPfvId;
      this.linkNotes.parent_id = tempPfvId;
      this.linkType.parent_id = tempPfvId;
      this.sourceProject.customFields.push({ ...this.linkUrl });
      this.sourceProject.customFields.push({ ...this.linkLabel });
      this.sourceProject.customFields.push({ ...this.linkNotes });
      this.sourceProject.customFields.push({ ...this.linkType });
    },
    removeDuplicationResource(resourcePfvId) {
      const filteredFields = this.sourceProject.customFields.filter(field => !(field.pfv_id === resourcePfvId || field.parent_id === resourcePfvId));
      this.$set(this.sourceProject, 'customFields', filteredFields);
    },
    getLinkTypeObject(id) {
      const linkTypeId = id == null ? 1 : id;
      return this.optionsForLinkType.find(option => option.id == linkTypeId) || this.optionsForLinkType[0] || { icon: 'link-url.svg' };
    },
    onDeadlineSelected(date) {
      if (date) {
        const formatted = [
          date.getFullYear(),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0'),
        ].join('-');
        this.$set(this.sourceProject, 'due_date', formatted);
      }
      this.editDeadline = false;
    },
  },
};
</script>

<style scoped>
#edit__project__modal.duplicate-preview {
  padding-top: 0 !important;
}

.duplicate-preview .project--top--section {
  margin-top: 0px;
  /* padding-top: 0; */
}

.duplicate-field-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}
.duplicate-checkbox {
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  z-index: 1;
}
.duplicate-field-content {
  flex: 1;
  min-width: 0;
}

.select-all-checkbox {
  font-size: 13px;
}

.duplicate-preview .field-box {
  margin-bottom: 0;
}
</style>

<style lang="scss">
.duplicate-step1{
  .project--page--title{
    .text--section{
      margin-left: 0!important;
      h1{
        color: var(--wf-primary);
        font-weight: 600;
      }
    }
    .project-number{
      span{
        font-size: 22px;
        color: #000;
        font-weight:500;
      }
    }
  }
  .project--top--section{
    padding: 20px 50px;
    .left--side{
      .field-label{
        color: #000;
        font-size: 16px;
      }
      .project--resources{
        .add-resource-button{
          color: #000;
        }
        .project--resources--content{
          .resource-entry{
            border: 1px solid #eeeeee;
          }
        }
      }
      .project--page--title{
        .text--section{
           .department-title{
            color: #999;
           }
        }
      }
    }
    .right--side{
      .project-right-side-fields{
        .edit-d-title{
          color: #000;
        }
      }
    }
  }
  .project-due-date{
    color: #000;
  }
  .editable-project-due-date{
    .vdp-datepicker{
      input{
        color: #000;
      }
      input::placeholder{
        color: #000;
      }
    }
  }
}

</style>